module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "persistent": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "enable-resize-watcher": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": "",
        "d-none": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n              " + _vm._s(item.heading) + "\n            ")]) : _vm._e()], 1)], 1) : (item.divider) ? _c('v-divider', {
      key: i,
      staticClass: "my-1",
      attrs: {
        "dark": ""
      }
    }) : _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.$router.push(item.href)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "vl-header",
      "dark": "",
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clipped = !_vm.clipped
      }
    }
  }, [_c('v-icon', [_vm._v("web")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "text-right w-100",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('main', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "fixed": _vm.fixed,
      "app": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "https://vajralab.com",
      "target": "_blank"
    }
  }, [_vm._v("VajraLab")]), _vm._v(" © 2019-2023")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75775e82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 106
// module chunks = 0